import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { t } from 'i18next';

type DeleteMaterialDialogProps = {
  isOpen: boolean;
  onDelete: () => void;
  onCancel: () => void;
  materialName: string;
};

export default function DeleteMaterialDialog({ isOpen, onDelete, onCancel, materialName }: DeleteMaterialDialogProps) {
  return (
    <Dialog open={isOpen} onClose={onCancel}>
      <DialogTitle>{t('common.delete')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('billableMaterial.deleteWarning', { materialName })}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t('common.cancel')}</Button>
        <Button onClick={onDelete} color='error' variant='contained'>
          {t('common.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
